import React, { useState, useRef } from 'react'
import { ChevronDown } from 'lucide-react'
import { MENU } from '@/config/menu.config'
import { MegaMenu } from './MegaMenu'
import { SectorsMenu } from './SectorsMenu'
import { CompanyMenu } from './CompanyMenu'
import { cn } from '@/lib/utils'
import { useLocation } from 'react-router-dom'

export function NavBar() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout>()
  const location = useLocation()

  const handleMouseEnter = (label: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    // Only set active menu for items with dropdown children
    const menuItem = MENU.find(item => item.label === label)
    if (menuItem?.children) {
      setActiveMenu(label)
    }
  }

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveMenu(null)
    }, 150)
  }

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/'
    return location.pathname.startsWith(href)
  }

  return (
    <div className="relative">
      <nav 
        className="flex items-center justify-center space-x-10"
        onMouseLeave={handleMouseLeave}
      >
        {MENU.map((item) => (
          <div key={item.label} className="relative">
            {item.children ? (
              <button
                className={cn(
                  "flex items-center space-x-2 px-6 py-4 text-base font-medium transition-colors duration-200 whitespace-nowrap",
                  "hover:text-primary focus:outline-none",
                  activeMenu === item.label ? "text-primary" : "text-foreground/80"
                )}
                onMouseEnter={() => handleMouseEnter(item.label)}
                aria-expanded={activeMenu === item.label}
                aria-haspopup="true"
              >
                <span className="whitespace-nowrap">{item.label}</span>
                <div
                  className="transition-transform duration-200"
                  style={{ transform: activeMenu === item.label ? 'rotate(180deg)' : 'rotate(0deg)' }}
                >
                  <ChevronDown className="w-4 h-4" />
                </div>
              </button>
            ) : (
              <a
                href={item.href}
                className={cn(
                  "flex items-center px-6 py-4 text-base font-medium transition-colors duration-200 whitespace-nowrap",
                  "hover:text-primary focus:outline-none",
                  isActive(item.href!) ? "text-primary" : "text-foreground/80"
                )}
              >
                <span className="whitespace-nowrap">{item.label}</span>
              </a>
            )}
          </div>
        ))}
      </nav>

      {/* Dropdown Menus - Positioned relative to the entire navbar */}
      {activeMenu === 'Services' && (
        <MegaMenu 
          onMouseEnter={() => handleMouseEnter('Services')}
          onMouseLeave={handleMouseLeave}
        />
      )}
      {activeMenu === 'Sectors' && (
        <SectorsMenu 
          onMouseEnter={() => handleMouseEnter('Sectors')}
          onMouseLeave={handleMouseLeave}
        />
      )}
      {activeMenu === 'Company' && (
        <CompanyMenu 
          onMouseEnter={() => handleMouseEnter('Company')}
          onMouseLeave={handleMouseLeave}
        />
      )}
    </div>
  )
}